(function () {
  // Guard against double-binding if this file's <script> tag ends up on the
  // page more than once (e.g. rendered once on the product page and again
  // inside a "Choose options" quick-add modal).
  if (window.__sizeChartInit) return;
  window.__sizeChartInit = true;

  // Caches trigger -> modal pairings once resolved, so we don't have to
  // re-query the DOM after a modal has been moved to <body> (see below).
  var triggerModalMap = new WeakMap();

  function getModalForTrigger(trigger) {
    if (triggerModalMap.has(trigger)) {
      return triggerModalMap.get(trigger);
    }

    var root = trigger.closest('[data-size-chart-root]');
    var modal = root && root.querySelector('[data-size-chart-modal]');
    if (!modal) return null;

    // Move the modal to <body>. If this markup is rendered inside a
    // "Choose options" / quick-add dialog that applies its own CSS
    // transform to animate open/closed, position:fixed children are
    // confined to that dialog instead of the real viewport - which is
    // what was clipping the close button. Re-parenting to <body> avoids
    // that entirely, regardless of where the trigger lives.
    document.body.appendChild(modal);

    triggerModalMap.set(trigger, modal);
    return modal;
  }

  function openModal(modal, trigger) {
    modal.hidden = false;
    document.body.classList.add('size-chart-modal-open');
    trigger.setAttribute('aria-expanded', 'true');
    modal.__triggerEl = trigger;

    var closeBtn = modal.querySelector('.size-chart__modal-close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    modal.hidden = true;
    document.body.classList.remove('size-chart-modal-open');
    if (modal.__triggerEl) {
      modal.__triggerEl.setAttribute('aria-expanded', 'false');
      modal.__triggerEl.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-size-chart-trigger]');
    if (trigger) {
      var modal = getModalForTrigger(trigger);
      if (modal) openModal(modal, trigger);
      return;
    }

    var closeEl = e.target.closest('[data-size-chart-close]');
    if (closeEl) {
      var openModalEl = closeEl.closest('[data-size-chart-modal]');
      if (openModalEl) closeModal(openModalEl);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-size-chart-modal]').forEach(function (modal) {
      if (!modal.hidden) closeModal(modal);
    });
  });
})();
